export function limitString(input: string, limit: number, suffix: string = '...'): string {
    if (input.length <= limit) {
        return input;
    }

    return input.slice(0, limit - suffix.length) + suffix;
}

export function getNameInitials(name: string): string {
    return name
        .split(' ', 2)
        .map((part) => part.charAt(0))
        .join('');
}

export function formatSeconds(totalSeconds: number): string {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const minutesStr = minutes.toString().padStart(2, '0');
    const secondsStr = seconds.toString().padStart(2, '0');
    return `${minutesStr}:${secondsStr}`;
}

export function formatDate(date?: Date|string|number|null|undefined, defaultValue = '-'): string {
    if (typeof date === 'string' || typeof date === 'number') {
        date = new Date(date);
    }

    if (!date || isNaN(date.getTime())) {
        return defaultValue;
    }

    const day = date.getDate();
    const month = (date.getMonth() + 1);
    const year = date.getFullYear();

    return `${day}. ${month}. ${year}`;
}

export function formatDateTime(date?: Date|string|number|null|undefined, defaultValue = '-'): string {
    if (typeof date === 'string' || typeof date === 'number') {
        date = new Date(date);
    }

    if (!date || isNaN(date.getTime())) {
        return defaultValue;
    }

    const day = date.getDate();
    const month = (date.getMonth() + 1);
    const year = date.getFullYear();

    // Prefix with leading zero if needed
    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');

    return `${day}. ${month}. ${year} ${hours}:${minutes}`;
}

export function formatNumber(
    value: number|null|undefined, 
    decimals = 0, 
    thousandsSeparator = ' ', 
    decimalSeparator = ',', 
    defaultValue = '-'
): string {
    // Check if the input is a valid number
    if (value === null || value === undefined || isNaN(value)) {
        return defaultValue;
    }
  
    // Fix the number of decimals
    const number = value.toFixed(decimals);
  
    // Split the number into parts (integer and decimal)
    const parts = number.split('.');
  
    // Replace the thousand separator
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
  
    // Join the integer and decimal parts with the decimal separator
    return parts.join(decimalSeparator);
}
